import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { DocumentoObras } from '../../models/documento-obras.model';
import { DocumentoObrasService } from '../../services/documento-obras.services';

@Component({
  selector: 'app-documento-obras-edit',
  templateUrl: './documento-obras-edit.component.html',
  styleUrls: ['./documento-obras-edit.component.scss']
})
export class DocumentoObrasEditComponent extends BaseFormComponent<DocumentoObras> implements OnInit {

  idObra: number;
  actionLabel: string = 'Novo';
  selectedFile: File | null = null;
  list: any;

  constructor(
    private myService: DocumentoObrasService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.list = this.activatedRoute.snapshot.data['list'];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      type_id: new FormControl(null),
      file: new FormControl(null, [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.form.get("file").clearValidators();
      this.form.get("file").updateValueAndValidity();
    } else {
      this.idObra = this.activatedRoute.snapshot.queryParams['work_id'];
    }
  }

  voltar() {
    if (this.entity) {
      this.navigation.back(['/qrobras', 'obra', this.entity?.work_id]);
    } else {
      this.navigation.back(['/qrobras', 'obra', this.idObra]);
    }
  }

  getDataCreate() {
    let data: DocumentoObras;
    data = Object.assign({}, data, this.form.value);

    if (!this.entity?.id) {
      data.work_id = this.idObra;
    }

    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (key == "file" && this.selectedFile) {
          formData.append('file', this.selectedFile, this.selectedFile?.name);
        }
        else {
          if (data[key]) {
            formData.append(key, data[key]);
          }
        }
      }
    }
    return formData;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.updateDocumento(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.entity = res;
              this.msgSuccess('Documento alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.createDocumento(this.getDataCreate()).subscribe({
            next: (res) => {
              this.confirmation('Documento criado com sucesso!').subscribe(() => {
                this.navigation.replace(['/qrobras', 'obra', this.idObra]);
              });
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  onFileSelected(event: any): void {
    this.selectedFile = event?.target?.files[0];
  }

  download() {
    this.loading();
    this.addSub(
      this.myService.download(this.entity?.id).subscribe({
        next: (res) => {
          const contentDispositionHeader = res.headers.get('content-disposition');
          const fileName = contentDispositionHeader ? this.myService.extractFilename(contentDispositionHeader) : this.entity?.name;
          const blob = new Blob([res.body], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          this.loaded();
        },
        error: (error) => {
          let msg;
          if (error?.status == 404) {
            msg = "Arquivo não encontrado.";
          }
          this.msgError(msg ? msg : error?.error?.message);
          this.loaded();
        },
      })
    );
  }
}

